import type { OrganizationAccessMode } from '../../../api/organization/organizationApiTypes';
import { spaceOf } from '../../../utils/useCases';

/**
 * Whether an organisation's access to a room gets the allocation-window editor
 * (ADR-0027). The one place both the organisation's page and the room's page
 * ask it.
 *
 * - **shared**: always, for every room use case, as before.
 * - **public** (an open room): only for a use case with `allocationWindows`
 *   (the sports hall). PO, 2026-10-25: the editor appears for open access,
 *   and venues stay unchanged, so a venue on open access keeps showing none.
 * - **dedicated**: never; the room is the organisation's all the time and the
 *   API refuses windows on it.
 *
 * `roomUseCases` unknown (still loading, or failed) reads as "no windows" for
 * open access, which is what the screen showed before.
 */
export const windowEditorOffered = (
    accessMode: OrganizationAccessMode,
    roomUseCases: readonly string[] | undefined,
): boolean => {
    if (accessMode === 'shared') return true;
    if (accessMode !== 'public') return false;
    return (roomUseCases ?? []).some((useCase) => spaceOf(useCase)?.allocationWindows === true);
};
